import { twMerge } from 'tailwind-merge';
import { formatPercentage } from '@witmetrics/utils/strings';
import LoopingEllipsis from '@/components/LoopingEllipsis';
import ProgressBar from '@/components/ProgressBar';
import { classes } from './utils';

export type LoadingProgressProps = {
  className?: string;
  label?: string;
  progress: number;
};

export default function LoadingProgress({
  className,
  label = 'Loading',
  progress,
}: LoadingProgressProps) {
  return (
    <div className={twMerge(classes.wrapper, className)}>
      <div className={classes.label}>
        {label}
        <LoopingEllipsis />
      </div>
      <div className={classes.label}>{formatPercentage(progress, 0)}</div>
      <ProgressBar className={classes.progressBar} progress={100 * progress} />
    </div>
  );
}
